<template>
  <v-menu left bottom close transition="slide-y-transition" offset-y dense close-on-click close-on-content-click>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" class="hidden-md-and-up">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list class="py-0">
      <v-list-item-group color="grey darken-4">
        <!--TODO: CHECK IF THIS WORKS WITH THE RIGHT DATA SET-->
        <v-list-item v-if="currentFileProperties.confirm && currentFile.unconfirmed" @click="$emit('set-confirmation', currentFile.id)">
          <v-list-item-icon class="mr-4">
            <v-icon>mdi-pencil</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('mm.confirm') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="currentFileProperties.pin && !currentFile.favorite" @click="$emit('set-favorite', { id: currentFile.id, status: true })">
          <v-list-item-icon class="mr-4">
            <v-icon>mdi-heart-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('mm.addtofavorites') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="currentFileProperties.pin && currentFile.favorite" @click="$emit('set-favorite', { id: currentFile.id, status: false })">
          <v-list-item-icon class="mr-4">
            <v-icon>mdi-heart</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('mm.removefromfavorites') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    currentFileProperties: {
      type: Object,
      default: () => ({}),
    },
    currentFile: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
